<template>
	<div>
		<b-form-input
			:type="fieldInfo.type"
			:id="fieldInfo.id"
			:min="min"
			:max="max"
			:value="value"
			:state="state"
			:size="fieldInfo.size"
			:maxlength="maxlength"
			:minlength="minlength"
			v-model="proxyValue"
			:name="fieldInfo.name"
			@blur="emitBlur"
			:readonly="!active"
			:placeholder="fieldInfo.placeholder"
			:disabled="disabled"
			@keypress.enter="emitEnterEvent"
			v-mask="fieldInfo.mask"
			:formatter="needsFormatter ? defaultFormatter : null"
			@keydown="emitKeyDownEvent"
			@input="handleInput"
			autocomplete="off"
			ref="inputElement"
		/>
		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		fieldInfo: {
			type: Object
		},
		min: {
			type: Number
		},
		customMask: {
			type: String
		},
		formatter: {
			type: Function
		},
		textCasing: {
			type: String,
			validator(value) {
				return [this.$LetterCaseEnum.Upper, this.$LetterCaseEnum.Lower, this.$LetterCaseEnum.All].includes(value);
			}
		},
		allowedChar: {
			type: Object
		},
		max: {
			type: Number
		},
		value: {
			type: [String, Number]
		},
		state: {
			type: Boolean
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		disabled: {
			type: [Boolean, Function],
			required: false
		},
		maxlength: {
			type: [Number]
		},
		minlength: {
			type: [Number]
		},
		toUpperCase: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			active: true,
			isUpdating: false
		};
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.fieldInfo.name);
			}
		},
		needsFormatter() {
			const allowedChar = Array.isArray(this.allowedChar) ? this.allowedChar : [];
			const usedTextCasing =
				this.textCasing == this.$LetterCaseEnum.Upper || this.textCasing == this.$LetterCaseEnum.Lower;
			const usedFormatter = typeof this.formatter === "function";
			const usedMask = !!this.customMask;
			const allowedCharUsed = allowedChar.length > 0;

			return allowedCharUsed || usedTextCasing || usedFormatter || usedMask;
		}
	},
	methods: {
		getValue: function () {
			this.$emit("value", this.value);
		},
		emitBlur: function () {
			this.$emit("change", this.fieldInfo.name);
			this.$emit("blur", this.fieldInfo);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		emitEnterEvent: function () {
			this.$emit("enterPress");
		},
		emitKeyDownEvent(event) {
			this.$emit("keyDownPress", event);
		},
		getInputElement() {
			// Se é um b-form-input, o elemento real está em $el
			if (this.$refs.inputElement && this.$refs.inputElement.$el) {
				return this.$refs.inputElement.$el;
			}
			// Fallback para input direto
			return this.$refs.inputElement;
		},
		handleInput(event) {
			if (this.toUpperCase && !this.needsFormatter && !this.isUpdating) {
				const input = this.getInputElement();
				const { cursorPosition, currentValue } = this.$functions.getCursorPositionAndValue(input, event, this.value);

				this.$functions.applyUpperCaseWithCursorPreservation(
					currentValue,
					cursorPosition,
					input,
					(upperValue) => {
						this.isUpdating = true;
						this.proxyValue = upperValue;
						// Callback para resetar isUpdating após restaurar cursor
						this.$functions.restoreCursorPosition(input, cursorPosition, () => {
							this.isUpdating = false;
						});
					}
				);
			}
		},
		defaultFormatter(value) {
			return this.$functions.defaultFormatter(value, {
				allowedChar: this.allowedChar,
				textCasing: this.textCasing,
				formatter: this.formatter,
				customMask: this.customMask,
				toUpperCase: this.toUpperCase
			});
		}
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>
